/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ParametroProgramaModelDto } from '../models/parametro-programa-model-dto';
import { programaParametrosControllerGetProgramParametrizaciones } from '../fn/programa-parametros/programa-parametros-controller-get-program-parametrizaciones';
import { ProgramaParametrosControllerGetProgramParametrizaciones$Params } from '../fn/programa-parametros/programa-parametros-controller-get-program-parametrizaciones';
import { programaParametrosControllerUpdateProgramaParametro } from '../fn/programa-parametros/programa-parametros-controller-update-programa-parametro';
import { ProgramaParametrosControllerUpdateProgramaParametro$Params } from '../fn/programa-parametros/programa-parametros-controller-update-programa-parametro';

@Injectable({ providedIn: 'root' })
export class ProgramaParametrosService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `programaParametrosControllerGetProgramParametrizaciones()` */
  static readonly ProgramaParametrosControllerGetProgramParametrizacionesPath = '/api/programa-parametros/{programaUuid}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `programaParametrosControllerGetProgramParametrizaciones()` instead.
   *
   * This method doesn't expect any request body.
   */
  programaParametrosControllerGetProgramParametrizaciones$Response(params: ProgramaParametrosControllerGetProgramParametrizaciones$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ParametroProgramaModelDto>>> {
    return programaParametrosControllerGetProgramParametrizaciones(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `programaParametrosControllerGetProgramParametrizaciones$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  programaParametrosControllerGetProgramParametrizaciones(params: ProgramaParametrosControllerGetProgramParametrizaciones$Params, context?: HttpContext): Observable<Array<ParametroProgramaModelDto>> {
    return this.programaParametrosControllerGetProgramParametrizaciones$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ParametroProgramaModelDto>>): Array<ParametroProgramaModelDto> => r.body)
    );
  }

  /** Path part for operation `programaParametrosControllerUpdateProgramaParametro()` */
  static readonly ProgramaParametrosControllerUpdateProgramaParametroPath = '/api/programa-parametros/{uuidPrograma}';

  /**
   * Actualizar parametrización de un programa.
   *
   * Actualiza los parámetros de un programa dado su UUID. Requiere una lista de parametrizaciones con sus valores mínimos y máximos.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `programaParametrosControllerUpdateProgramaParametro()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  programaParametrosControllerUpdateProgramaParametro$Response(params: ProgramaParametrosControllerUpdateProgramaParametro$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return programaParametrosControllerUpdateProgramaParametro(this.http, this.rootUrl, params, context);
  }

  /**
   * Actualizar parametrización de un programa.
   *
   * Actualiza los parámetros de un programa dado su UUID. Requiere una lista de parametrizaciones con sus valores mínimos y máximos.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `programaParametrosControllerUpdateProgramaParametro$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  programaParametrosControllerUpdateProgramaParametro(params: ProgramaParametrosControllerUpdateProgramaParametro$Params, context?: HttpContext): Observable<void> {
    return this.programaParametrosControllerUpdateProgramaParametro$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
